import { render, staticRenderFns } from "./renja_evaluasi_program.vue?vue&type=template&id=3583fd90&"
import script from "./renja_evaluasi_program.vue?vue&type=script&lang=js&"
export * from "./renja_evaluasi_program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports